import Vue from "vue";
import Swal from 'sweetalert2'
window.Swal = Swal;
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000
});
window.Toast = Toast;

/**
 * [ReadLaravelErrors description]
 * Solo para la lectura de respuesta de error 
 * laravel api
 * Nota: no para otro caso de uso
 * @param {Object} errors [description]
 */
function ReadLaravelErrors(errors) {
    console.log("Entrando a la funcion");
    try {
        let list = "";
        for (const prop in errors) {
            // console.log(errors[prop][0]);
            list = list + `<li>${errors[prop][0]}</li>`;
        }

        Swal.fire({
            titleText: "¡Ups!",
            html: list,
            // type: "error",
            customClass: {
                popup: "round-small",
                confirmButton: "teal-btn"
            }
        });
    } catch (error) {
        console.warn(
            'el registro no corresponde a una respuesta error de laravel',
        );
    }
}

Vue.prototype.$laravelerrors = ReadLaravelErrors;